import { useColorModeValue } from '@chakra-ui/react'
import { ResponsiveLine } from '@nivo/line'
import { themeDark, themeLight } from 'theme/charts'

interface Props {
    data: any[]
    tooltip?: (args1: any) => React.ReactNode
    customProps?: any
}

const Lines = ({ data, tooltip, customProps }: Props) => {
    const theme = useColorModeValue(themeLight, themeDark)

    return (
        <ResponsiveLine
            data={data}
            theme={theme}
            tooltip={(values) => tooltip ? tooltip(values) : null}
            xScale={{ type: 'point' }}
            yScale={{
                type: 'linear',
                min: 'auto',
                max: 'auto',
                stacked: false,
                reverse: false
            }}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legendPosition: "middle",
                legendOffset: 32
            }}
            axisLeft={{
                tickValues: 5,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legendPosition: "middle",
                legendOffset: -40
            }}
            margin={{
                top: 10,
                right: 10,
                bottom: 25,
                left: 25
            }}
            colors={["#3E993C"]}
            pointSize={8}
            pointColor={{ from: 'color', modifiers: [] }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh={true}
            {...customProps}
        />
    )
}

export default Lines